import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { DBDef_EHRInstanceKBVersion } from './db-def.js';
export const ApiDef_EHRInstanceKBVersion = {
    _v1: {
        'create-item': { method: HttpMethod.POST, path: `_v1/${DBDef_EHRInstanceKBVersion.dbKey}/create-item` },
    }
};
//# sourceMappingURL=api-def.js.map